import React from 'react';

import taskIcon from '@assets/icons/task.svg';
import { Table, TablePageIndicator } from '@components';
import { getTaskStatus } from '@features/lead-management/utils/leadActivity';
import { formatISODate } from '@utils/date';

import ActionButton from '../ActionButton';

import {
  TASK_COLOR_CLASS,
  TASK_STATUS_LABEL,
  TASK_TYPE_LABEL,
  taskColumns
} from '../../constants/leadActivity';
import { TaskTableProps } from '../../types/leadActivity';

const TaskTable: React.FC<TaskTableProps> = ({
  tasks,
  page,
  totalCount,
  setPage,
  handleMenuIconClick
}) => {
  const tableData = tasks.map((task) => {
    const taskDate = formatISODate({
      date: task.timestamp,
      format: 'dd-mm-yyyy',
      separator: '/'
    });
    const taskTime = formatISODate({
      date: task.timestamp,
      format: 'hh:mm am/pm'
    });
    const formattedDate = formatISODate({
      date: task.timestamp,
      format: 'yyyy-mm-dd',
      separator: '-'
    });
    const taskStatus = getTaskStatus(formattedDate, taskTime, task.status);
    return {
      id: task.id,
      name: task.name,
      task_type:
        TASK_TYPE_LABEL[
          task.task_type as unknown as keyof typeof TASK_TYPE_LABEL
        ],
      timestamp: taskDate,
      time: taskTime,
      status: (
        <div
          className={`${
            TASK_COLOR_CLASS[taskStatus as keyof typeof TASK_COLOR_CLASS]
          } rounded-xl px-2 py-1  text-center font-normal`}
        >
          {TASK_STATUS_LABEL[taskStatus as keyof typeof TASK_STATUS_LABEL]}
        </div>
      ),
      actions: (
        <ActionButton
          item={task}
          handleEditAction={(item) => handleMenuIconClick(item.id, 'edit')}
          handleDeleteAction={(item) => handleMenuIconClick(item.id, 'delete')}
          actions={['edit', 'delete']}
        />
      )
    };
  });

  return (
    <div className="space-y-4">
      {tasks.length === 0 ? (
        <div className="flex h-full items-center justify-center">
          <div className="py-8 text-center text-gray-500">
            <img src={taskIcon} alt="task" className="mx-auto mb-2" />
            <p>
              No tasks scheduled yet. Stay on top of your leads create your task
            </p>
          </div>
        </div>
      ) : (
        <>
          <Table
            columns={taskColumns}
            data={tableData}
            isRowClickRequired={false}
            handleSelect={() => {}}
            disabledRowIds={[]}
            className="h-fit"
          />
          {totalCount > 0 && (
            <TablePageIndicator
              currentPage={page}
              totalCount={totalCount}
              onPageChange={setPage}
            />
          )}
        </>
      )}
    </div>
  );
};

export default TaskTable;
